/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerVisits200ResponseItemsInnerReview } from './GetCustomerVisits200ResponseItemsInnerReview';
import {
    GetCustomerVisits200ResponseItemsInnerReviewFromJSON,
    GetCustomerVisits200ResponseItemsInnerReviewFromJSONTyped,
    GetCustomerVisits200ResponseItemsInnerReviewToJSON,
    GetCustomerVisits200ResponseItemsInnerReviewToJSONTyped,
} from './GetCustomerVisits200ResponseItemsInnerReview';

/**
 * 
 * @export
 * @interface GetCustomerVisits200ResponseItemsInner
 */
export interface GetCustomerVisits200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    label: GetCustomerVisits200ResponseItemsInnerLabelEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    type: GetCustomerVisits200ResponseItemsInnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    diners?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    locationName: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    comment?: string;
    /**
     * 
     * @type {GetCustomerVisits200ResponseItemsInnerReview}
     * @memberof GetCustomerVisits200ResponseItemsInner
     */
    review?: GetCustomerVisits200ResponseItemsInnerReview;
}


/**
 * @export
 */
export const GetCustomerVisits200ResponseItemsInnerLabelEnum = {
    Open: 'open',
    Upcoming: 'upcoming',
    Paid: 'paid',
    Pending: 'pending',
    Noshow: 'noshow',
    Cancelled: 'cancelled'
} as const;
export type GetCustomerVisits200ResponseItemsInnerLabelEnum = typeof GetCustomerVisits200ResponseItemsInnerLabelEnum[keyof typeof GetCustomerVisits200ResponseItemsInnerLabelEnum];

/**
 * @export
 */
export const GetCustomerVisits200ResponseItemsInnerTypeEnum = {
    Restaurant: 'restaurant',
    Delivery: 'delivery',
    Takeaway: 'takeaway',
    Reservation: 'reservation'
} as const;
export type GetCustomerVisits200ResponseItemsInnerTypeEnum = typeof GetCustomerVisits200ResponseItemsInnerTypeEnum[keyof typeof GetCustomerVisits200ResponseItemsInnerTypeEnum];


/**
 * Check if a given object implements the GetCustomerVisits200ResponseItemsInner interface.
 */
export function instanceOfGetCustomerVisits200ResponseItemsInner(value: object): value is GetCustomerVisits200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    return true;
}

export function GetCustomerVisits200ResponseItemsInnerFromJSON(json: any): GetCustomerVisits200ResponseItemsInner {
    return GetCustomerVisits200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerVisits200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'],
        'type': json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'date': (new Date(json['date'])),
        'diners': json['diners'] == null ? undefined : json['diners'],
        'locationName': json['locationName'],
        'source': json['source'] == null ? undefined : json['source'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'review': json['review'] == null ? undefined : GetCustomerVisits200ResponseItemsInnerReviewFromJSON(json['review']),
    };
}

export function GetCustomerVisits200ResponseItemsInnerToJSON(json: any): GetCustomerVisits200ResponseItemsInner {
    return GetCustomerVisits200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseItemsInnerToJSONTyped(value?: GetCustomerVisits200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'type': value['type'],
        'amount': value['amount'],
        'date': ((value['date']).toISOString()),
        'diners': value['diners'],
        'locationName': value['locationName'],
        'source': value['source'],
        'comment': value['comment'],
        'review': GetCustomerVisits200ResponseItemsInnerReviewToJSON(value['review']),
    };
}

